import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { ButtonProps, Button } from '../Button';
import { Icon, IconNames } from '../Icon';

export interface IconButtonProps extends Omit<ButtonProps, 'children'> {
  icon: IconNames;
}

export function IconButton({
  className,
  icon,
  ...props
}: IconButtonProps): ReactElement {
  const classes = classnames('btn--circle', className);

  return (
    <Button {...props} className={classes}>
      <Icon name={icon} />
    </Button>
  );
}
